if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.mediaItems = [];
        this.prevButton = null;
        this.nextButton = null;
      }

      connectedCallback() {
        super.connectedCallback();
        
        // Find navigation buttons
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        
        // Add event listeners
        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.navigatePrev.bind(this));
          this.prevButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.navigateNext.bind(this));
          this.nextButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }

        // Add keyboard navigation
        this.addEventListener('keydown', this.handleKeyDown.bind(this));
        
        // Zoom functionality
        this.addEventListener('click', this.handleModalClick.bind(this));
        this.addEventListener('mousemove', this.panImage.bind(this));
      }

      hide() {
        super.hide();
        this.resetZoom();
      }

      show(opener) {
        super.show(opener);
        this.initializeSlider();
        this.showActiveMedia();
      }

      initializeSlider() {
        // Get all media items
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        
        // Find index of currently opened media
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        this.currentIndex = this.mediaItems.findIndex(
          item => item.getAttribute('data-media-id') === openedMediaId
        );
        
        if (this.currentIndex === -1) this.currentIndex = 0;
        
        this.updateNavigationButtons();
      }

      showActiveMedia() {
        this.resetZoom();
        if (this.mediaItems.length === 0) return;

        // Hide all media items
        this.mediaItems.forEach((element) => {
          element.classList.remove('active');
          element.style.display = 'none';
        });

        // Show active media item
        const activeMedia = this.mediaItems[this.currentIndex];
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        
        activeMedia.classList.add('active');
        activeMedia.style.display = 'block';

        // Reset scroll position
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }

        // Load deferred media if needed
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavigationButtons();
      }

      navigatePrev() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.showActiveMedia();
        } else {
          // Loop to last image
          this.currentIndex = this.mediaItems.length - 1;
          this.showActiveMedia();
        }
      }

      navigateNext() {
        if (this.currentIndex < this.mediaItems.length - 1) {
          this.currentIndex++;
          this.showActiveMedia();
        } else {
          // Loop to first image
          this.currentIndex = 0;
          this.showActiveMedia();
        }
      }

      updateNavigationButtons() {
        if (!this.prevButton || !this.nextButton) return;

        // Always show buttons for infinite loop
        this.prevButton.style.display = 'flex';
        this.nextButton.style.display = 'flex';
      }

      handleKeyDown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.navigatePrev();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.navigateNext();
        }
      }

      handleModalClick(event) {
        if (event.target.tagName !== 'IMG' || event.target.closest('.product-media-modal__toggle')) return;
        event.stopPropagation(); // Prevent closing
        this.toggleZoom(event);
      }

      toggleZoom(event) {
        const image = event.target;
        const isZoomed = image.classList.contains('zoomed');

        if (isZoomed) {
          this.resetZoom(image);
        } else {
          image.classList.add('zoomed');
          image.style.transform = 'scale(2.5)';
          image.style.cursor = 'zoom-out';
          this.panImage(event); // Initial pan
        }
      }

      resetZoom(image) {
        const activeImage = image || this.querySelector('.active img');
        if (activeImage) {
          activeImage.classList.remove('zoomed');
          activeImage.style.transform = '';
          activeImage.style.transformOrigin = '';
          activeImage.style.cursor = 'zoom-in';
        }
      }

      panImage(event) {
        const activeImage = this.querySelector('.active img.zoomed');
        if (!activeImage) return;

        const rect = this.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        activeImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      }
    }
  );
}
